import { shallowEqual, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { AnalyticsPostPurchaseBreakdown } from '@components/Analytics/Breakdown/PostPurchaseBreakdown'
import { IApplicationState } from '@store'
import { selectSubmissionId } from '@store/router'
import {
  selectIsSubmissionFromInstagram,
  selectIsSubmissionFromX,
  selectIsVideoSocialSubmission,
  selectSubmission,
} from '@store/submissions'
import { getSubmissionFlags } from '@utils'
import AnalyticsPostPerformancePost from '../Post/Post'
import AnalyticsPostPerformanceVideo from '../Video/Video'

const AnalyticsPostPerformanceWrapper = () => {
  const match = useRouteMatch()
  const submissionId = selectSubmissionId(match) as number

  const { isVideo, showConsolidatedPostPurchase } = useSelector((state: IApplicationState) => {
    const submission = selectSubmission(state, submissionId)

    const isSubmissionFromInstagram = selectIsSubmissionFromInstagram(state, submissionId)
    const isSubmissionFromX = selectIsSubmissionFromX(state, submissionId)

    const { isShorts, isTiktok, isSnap } = getSubmissionFlags(submission)

    const showConsolidatedPostPurchase =
      isSubmissionFromInstagram || isTiktok || isSubmissionFromX || isSnap || isShorts

    return {
      isVideo: selectIsVideoSocialSubmission(state, submissionId),
      showConsolidatedPostPurchase,
    }
  }, shallowEqual)

  if (showConsolidatedPostPurchase) {
    return <AnalyticsPostPurchaseBreakdown submissionId={submissionId} />
  }

  if (isVideo) {
    return <AnalyticsPostPerformanceVideo />
  }

  return <AnalyticsPostPerformancePost />
}

export { AnalyticsPostPerformanceWrapper }
export default AnalyticsPostPerformanceWrapper
